/* Native progressive enhancement for the shared 2026 panels. */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-logo-carousel]').forEach(function (carousel) {
        var track = carousel.querySelector('.s26-logo-row');
        var items = Array.from(track.children);
        if (!items.length) return;

        var dots = document.createElement('nav');
        dots.className = 's26-logo-dots';
        dots.setAttribute('aria-label', 'Accreditations navigation');
        track.after(dots);

        var active = 0;
        var positionCount = 1;
        var positions = [0];
        var timer;
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function visibleCount() {
            return Math.max(1, Math.round(track.clientWidth / items[0].getBoundingClientRect().width));
        }

        function setActive(index, move) {
            active = Math.max(0, Math.min(index, positionCount - 1));
            Array.from(dots.children).forEach(function (button, buttonIndex) {
                button.setAttribute('aria-current', buttonIndex === active ? 'true' : 'false');
            });
            if (move) {
                track.scrollTo({
                    left: items[positions[active]].offsetLeft,
                    behavior: reducedMotion.matches ? 'auto' : 'smooth'
                });
            }
        }

        function layout() {
            var lastPosition = Math.max(0, items.length - visibleCount());
            positions = [0];
            for (var index = 2; index < lastPosition; index += 2) positions.push(index);
            if (lastPosition > 0 && positions[positions.length - 1] !== lastPosition) positions.push(lastPosition);
            positionCount = positions.length;
            dots.replaceChildren();
            dots.hidden = positionCount < 2;
            for (var dotIndex = 0; dotIndex < positionCount; dotIndex += 1) {
                var button = document.createElement('button');
                button.type = 'button';
                button.setAttribute('aria-label', 'Show logos from item ' + (positions[dotIndex] + 1));
                button.addEventListener('click', function (event) {
                    setActive(Array.from(dots.children).indexOf(event.currentTarget), true);
                    restart();
                });
                dots.append(button);
            }
            setActive(Math.min(active, positionCount - 1), true);
            restart();
        }

        function restart() {
            window.clearInterval(timer);
            if (positionCount < 2 || reducedMotion.matches) return;
            timer = window.setInterval(function () {
                setActive((active + 1) % positionCount, true);
            }, 4000);
        }

        var scrollFrame;
        track.addEventListener('scroll', function () {
            window.cancelAnimationFrame(scrollFrame);
            scrollFrame = window.requestAnimationFrame(function () {
                var itemWidth = items[0].getBoundingClientRect().width;
                var currentItem = Math.round(track.scrollLeft / itemWidth);
                var nearest = positions.reduce(function (best, position, index) {
                    return Math.abs(position - currentItem) < Math.abs(positions[best] - currentItem) ? index : best;
                }, 0);
                setActive(nearest, false);
            });
        }, {passive:true});
        carousel.addEventListener('mouseenter', function () { window.clearInterval(timer); });
        carousel.addEventListener('mouseleave', restart);
        carousel.addEventListener('focusin', function () { window.clearInterval(timer); });
        carousel.addEventListener('focusout', restart);
        track.addEventListener('pointerdown', function () { window.clearInterval(timer); });
        track.addEventListener('pointerup', restart);
        new ResizeObserver(layout).observe(track);
    });

    document.querySelectorAll('.s26-cards--tiles .s26-cards-list, .s26-cards--cards .s26-cards-list').forEach(function (track) {
        var drag;
        var suppressClick = false;
        track.addEventListener('pointerdown', function (event) {
            if (event.pointerType !== 'mouse' || event.button !== 0 || track.scrollWidth <= track.clientWidth) return;
            drag = { x: event.clientX, scroll: track.scrollLeft, moved: false };
        });
        track.addEventListener('pointermove', function (event) {
            if (!drag) return;
            if (!drag.moved && Math.abs(event.clientX - drag.x) <= 5) return;
            if (!drag.moved) {
                drag.moved = true;
                track.classList.add('is-dragging');
                track.setPointerCapture(event.pointerId);
            }
            track.scrollLeft = drag.scroll - (event.clientX - drag.x);
        });
        function endDrag() {
            if (!drag) return;
            suppressClick = drag.moved;
            drag = null;
            track.classList.remove('is-dragging');
            if (suppressClick) window.setTimeout(function () { suppressClick = false; }, 0);
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('lostpointercapture', endDrag);
        track.addEventListener('pointerleave', function () { if (drag && !drag.moved) drag = null; });
        track.addEventListener('dragstart', function (event) { event.preventDefault(); });
        track.addEventListener('click', function (event) {
            if (suppressClick) {
                event.preventDefault();
                event.stopPropagation();
                suppressClick = false;
            }
        }, true);
        var dots = document.createElement('nav');
        dots.className = 's26-card-dots';
        dots.setAttribute('aria-label', 'Card navigation');
        track.after(dots);
        var positions = [];
        function updateActive() {
            var nearest = positions.reduce(function (best, position, index) {
                return Math.abs(position - track.scrollLeft) < Math.abs(positions[best] - track.scrollLeft) ? index : best;
            }, 0);
            Array.from(dots.children).forEach(function (button, index) {
                button.setAttribute('aria-current', index === nearest ? 'true' : 'false');
            });
        }
        function layout() {
            var count = track.children.length;
            if (!count) return;
            var width = track.parentElement.clientWidth;
            var gap = parseFloat(getComputedStyle(track).columnGap) || 18;
            var visible = Math.min(4, Math.max(1, Math.floor((width + gap) / (300 + gap))));
            if (count > visible) visible = Math.min(4, Math.max(1, Math.floor((width - 32 + gap) / (300 + gap))));
            if (!document.body.classList.contains('s26-contracting') && track.closest('.s26-cards--related') && width >= 1000) visible = Math.min(4, count);
            var shown = Math.min(count, visible);
            var peek = count > visible ? 32 : 0;
            track.style.setProperty('--s26-card-width', ((width - peek - gap * (shown - 1)) / shown) + 'px');
            var max = track.scrollWidth - track.clientWidth;
            positions = [0];
            if (max > 1) {
                var step = track.firstElementChild.getBoundingClientRect().width + gap;
                for (var x = step; x < max; x += step) positions.push(x);
                positions.push(max);
            }
            dots.replaceChildren();
            dots.hidden = max <= 1;
            positions.forEach(function (position, index) {
                var button = document.createElement('button');
                button.type = 'button';
                button.setAttribute('aria-label', 'Show cards ' + (index + 1));
                button.addEventListener('click', function () {
                    track.scrollTo({left:position, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
                });
                dots.append(button);
            });
            updateActive();
        }
        track.addEventListener('scroll', updateActive, {passive:true});
        new ResizeObserver(layout).observe(track);
    });
    document.querySelectorAll('.s26-insight-track, .s26-cards--cards .s26-cards-list, .s26-cards--tiles .s26-cards-list').forEach(function (track) {
        var parent = track.parentElement;
        function extend() {
            var overflow = track.scrollWidth > parent.clientWidth + 1;
            var gutter = Math.max(0, document.documentElement.clientWidth - parent.getBoundingClientRect().right);
            track.style.setProperty('--s26-track-bleed', overflow ? gutter + 'px' : '0px');
        }
        new ResizeObserver(extend).observe(parent);
        new ResizeObserver(extend).observe(track);
    });
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('.s26-home-sparkle').forEach(function (sparkle) {
        var section = sparkle.parentElement;
        var stage = section.parentElement;
        stage.classList.add('s26-sparkle-stage');
        // Blend across both panels, outside the section's isolated background.
        section.before(sparkle);
        var position = function () {
            var slant = parseFloat(getComputedStyle(section).getPropertyValue('--slant-height')) || 0;
            sparkle.style.top = (section.offsetTop + slant * .73) + 'px';
        };
        var resize = new ResizeObserver(position);
        resize.observe(stage);
        resize.observe(section);
        position();
        new IntersectionObserver(function (entries) {
            sparkle.classList.toggle('is-visible', entries[0].isIntersecting);
        }).observe(section);
    });
    if (window.gsap && !reducedMotion.matches) {
        document.querySelectorAll('.s26-stat-grid').forEach(function (grid) {
            var stats = grid.querySelectorAll('.s26-stat');
            gsap.set(stats, {opacity:0, y:20});
            var observer = new IntersectionObserver(function (entries) {
                if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
                gsap.to(stats, {opacity:1, y:0, duration:0.65, stagger:0.2, ease:'power2.out', clearProps:'opacity,transform'});
                observer.disconnect();
            }, {threshold:0.15});
            observer.observe(grid);
        });
        document.querySelectorAll('.s26-hero-content, .s26-cta-copy:has(> h1)').forEach(function (hero) {
            var timeline = gsap.timeline({
                delay: 0.35,
                defaults: { duration: 0.8, ease: 'power2.out' },
            });
            timeline.fromTo(
                hero.querySelectorAll('h1, .s26-hero-intro, .s26-cta-copy > div'),
                { y: 28, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    stagger: 0.12,
                    clearProps: 'transform,opacity',
                },
            );
            var stats = hero.querySelector('.s26-hero-stats');
            if (stats) {
                timeline.fromTo(
                    stats,
                    { y: 18, opacity: 0 },
                    { y: 0, opacity: 1, clearProps: 'transform,opacity' },
                    0.45,
                );
            }
            timeline.fromTo(
                hero.querySelectorAll('.s26-button'),
                { opacity: 0 },
                {
                    opacity: 1,
                    clearProps: 'opacity',
                },
                0.6,
            );
        });

        var ctas = document.querySelectorAll('.s26-cta:not(.s26-cta--article) .s26-cta-copy:not(:has(> h1))');
        ctas.forEach(function (cta) {
            gsap.set(cta.children, { y: 24, opacity: 0 });
        });
        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    var cta = entry.target;
                    var sequence = gsap.timeline({ delay: 0.3 });
                    sequence.to(cta.children, {
                        y: 0,
                        opacity: 1,
                        duration: 0.65,
                        stagger: 0.12,
                        ease: 'power2.out',
                        clearProps: 'transform,opacity',
                    });
                    observer.unobserve(entry.target);
                });
            },
            { threshold: 0, rootMargin: '0px 0px -25% 0px' },
        );
        ctas.forEach(function (cta) {
            observer.observe(cta);
        });

        document.querySelectorAll('.s26-cards').forEach(function (section) {
            var cards = Array.from(section.querySelectorAll('article'));
            if (!cards.length) return;
            gsap.set(cards, { y: 28, opacity: 0 });
            var cardObserver = new IntersectionObserver(
                function (entries) {
                    if (!entries[0].isIntersecting) return;
                    if (reducedMotion.matches) {
                        gsap.set(cards, { clearProps: 'transform,opacity' });
                        cardObserver.disconnect();
                        return;
                    }
                    gsap.to(cards, {
                        y: 0,
                        opacity: 1,
                        duration: 0.75,
                        delay: 0.35,
                        stagger: 0.12,
                        ease: 'power2.out',
                        clearProps: 'transform,opacity',
                    });
                    cardObserver.disconnect();
                },
                { threshold: 0.15, rootMargin: '0px 0px -15% 0px' },
            );
            cardObserver.observe(section);
        });
        reducedMotion.addEventListener('change', function (event) {
            if (!event.matches) return;
            observer.disconnect();
            var targets = document.querySelectorAll(
                '.s26-hero-content h1, .s26-hero-intro, .s26-hero-stats, .s26-hero-content .s26-button, .s26-cta-copy > *, .s26-cards article',
            );
            gsap.killTweensOf(targets);
            gsap.set(targets, { clearProps: 'transform,opacity' });
        });
    }
    function rotateSlides(group, slides, current, activate, delay) {
        if (slides.length < 2) return;
        var timer,
            visible = false;
        function schedule() {
            clearTimeout(timer);
            if (
                !visible ||
                document.hidden ||
                reducedMotion.matches ||
                group.dataset.mobileAccordion === 'true' ||
                group.contains(document.activeElement)
            )
                return;
            timer = setTimeout(function () {
                activate((current() + 1) % slides.length, false);
                schedule();
            }, delay || 10000);
        }
        ['focusin', 'focusout', 'click'].forEach(function (event) {
            group.addEventListener(event, function () {
                setTimeout(schedule, 0);
            });
        });
        document.addEventListener('visibilitychange', schedule);
        reducedMotion.addEventListener('change', schedule);
        window.addEventListener('resize', schedule);
        new IntersectionObserver(
            function (entries) {
                visible = entries[0].isIntersecting;
                schedule();
            },
            { threshold: 0.2 },
        ).observe(group);
    }

    document.querySelectorAll('.s26-stat-grid').forEach(function (track) {
        var stats = Array.from(track.children);
        if (stats.length < 3) return;
        var tablet = window.matchMedia('(max-width:900px)');
        var mobile = window.matchMedia('(max-width:600px)');
        var active = 0;
        var dots = document.createElement('nav');
        dots.className = 's26-wrap s26-card-dots s26-stat-dots';
        dots.setAttribute('aria-label', 'Statistics navigation');
        track.after(dots);
        track.classList.add('s26-stat-carousel');
        function visibleCount() {
            return 3 - Number(tablet.matches) - Number(mobile.matches);
        }
        function positionCount() {
            return Math.max(1, stats.length - visibleCount() + 1);
        }
        function updateDots() {
            Array.from(dots.children).forEach(function (button, index) {
                button.setAttribute('aria-current', String(index === active));
            });
        }
        function move(index) {
            active = (index + positionCount()) % positionCount();
            var trackLeft = track.getBoundingClientRect().left;
            var cardLeft = stats[active].getBoundingClientRect().left;
            track.scrollTo({left:track.scrollLeft + cardLeft - trackLeft, behavior:reducedMotion.matches ? 'auto' : 'smooth'});
            updateDots();
        }
        track.addEventListener('scroll', function () {
            active = Math.min(positionCount() - 1, Math.round(track.scrollLeft / stats[0].getBoundingClientRect().width));
            updateDots();
        }, {passive:true});
        function arrange() {
            dots.replaceChildren();
            for (var index = 0; index < positionCount(); index++) {
                var button = document.createElement('button');
                button.type = 'button';
                button.setAttribute('aria-label', 'Show statistic ' + (index + 1));
                button.addEventListener('click', function (event) {
                    move(Array.from(dots.children).indexOf(event.currentTarget));
                });
                dots.append(button);
            }
            dots.hidden = positionCount() < 2;
            active = 0;
            track.scrollTo({left:0, behavior:'instant'});
            updateDots();
        }
        tablet.addEventListener('change', arrange);
        mobile.addEventListener('change', arrange);
        arrange();
        rotateSlides(track.parentElement, stats, function () { return active; }, move, 7000);
    });
    function enableSwipe(element, activateDirection) {
        if (!element) return;
        var startX = 0,
            startY = 0;
        element.addEventListener(
            'touchstart',
            function (event) {
                startX = event.changedTouches[0].clientX;
                startY = event.changedTouches[0].clientY;
            },
            { passive: true },
        );
        element.addEventListener(
            'touchend',
            function (event) {
                var deltaX = event.changedTouches[0].clientX - startX;
                var deltaY = event.changedTouches[0].clientY - startY;
                if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
                activateDirection(deltaX < 0 ? 1 : -1);
            },
            { passive: true },
        );
    }
    var toggle = document.querySelector('.s26-menu-toggle');
    if (toggle) {
        var header = toggle.closest('.s26-header');
        toggle.addEventListener('click', function () {
            var open = toggle.getAttribute('aria-expanded') !== 'true';
            toggle.setAttribute('aria-expanded', String(open));
            toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
            header.classList.toggle('is-open', open);
            document.documentElement.classList.toggle('s26-menu-open', open);
        });
        header.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && !header.querySelector('.s26-mega:not([hidden])')) {
                toggle.setAttribute('aria-expanded', 'false');
                toggle.setAttribute('aria-label', 'Open navigation');
                header.classList.remove('is-open');
                document.documentElement.classList.remove('s26-menu-open');
                toggle.focus();
            }
        });
        header.addEventListener('click', function (event) {
            if (!event.defaultPrevented && event.target.closest('a') && header.classList.contains('is-open')) {
                toggle.setAttribute('aria-expanded', 'false');
                toggle.setAttribute('aria-label', 'Open navigation');
                header.classList.remove('is-open');
                document.documentElement.classList.remove('s26-menu-open');
            }
        });
    }
    document.querySelectorAll('[data-service-tabs]').forEach(function (group) {
        var tabs = Array.from(group.querySelectorAll('.s26-tab'));
        var panels = Array.from(group.querySelectorAll('.s26-tab-panel'));
        var active = 0;
        var mobile = window.matchMedia('(max-width:600px)');
        var tabList = group.querySelector('.s26-tab-list');
        var stage = group.querySelector('.s26-slide-stage');
        group.classList.add('is-enhanced');
        group.querySelector('.s26-tab-list').setAttribute('role', 'tablist');
        function activate(index, focus) {
            active = index;
            tabs.forEach(function (tab, i) {
                tab.setAttribute('role', mobile.matches ? 'button' : 'tab');
                tab.setAttribute('aria-controls', panels[i].id);
                tab.setAttribute('aria-selected', String(i === index));
                if (mobile.matches) tab.setAttribute('aria-expanded', String(i === index));
                else tab.removeAttribute('aria-expanded');
                tab.tabIndex = mobile.matches || i === index ? 0 : -1;
                panels[i].setAttribute('role', mobile.matches ? 'region' : 'tabpanel');
                panels[i].tabIndex = 0;
                panels[i].hidden = i !== index;
                panels[i].inert = i !== index;
            });
            if (focus) tabs[index].focus();
        }
        tabs.forEach(function (tab, index) {
            tab.addEventListener('click', function (e) {
                e.preventDefault();
                activate(mobile.matches && active === index ? -1 : index, false);
                if (mobile.matches && active === index) {
                    tab.scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
                }
            });
            tab.addEventListener('keydown', function (e) {
                var next = index;
                if (mobile.matches && e.key === ' ') {
                    e.preventDefault();
                    activate(active === index ? -1 : index, false);
                    return;
                }
                if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
                else if (e.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
                else if (e.key === 'Home') next = 0;
                else if (e.key === 'End') next = tabs.length - 1;
                else return;
                e.preventDefault();
                activate(next, true);
            });
        });
        function arrangeTabs() {
            group.dataset.mobileAccordion = String(mobile.matches);
            if (mobile.matches) {
                tabList.removeAttribute('role');
                tabs.forEach(function (tab, index) {
                    tab.after(panels[index]);
                });
            } else {
                tabList.setAttribute('role', 'tablist');
                panels.forEach(function (panel) {
                    stage.appendChild(panel);
                });
            }
            if (tabs.length) activate(active < 0 && !mobile.matches ? 0 : active, false);
        }
        mobile.addEventListener('change', arrangeTabs);
        arrangeTabs();
        rotateSlides(
            group,
            panels,
            function () {
                return active;
            },
            activate,
        );
        enableSwipe(stage, function (direction) {
            if (!mobile.matches)
                activate((active + direction + panels.length) % panels.length, false);
        });
        function activateHash() {
            var index = panels.findIndex(function (panel) {
                return '#' + panel.id === window.location.hash;
            });
            if (index !== -1) activate(index, false);
        }
        activateHash();
        window.addEventListener('hashchange', activateHash);
        document.querySelectorAll('.s26-footer a').forEach(function (link) {
            if (
                link.origin !== window.location.origin ||
                link.pathname !== window.location.pathname
            )
                return;
            var index = panels.findIndex(function (panel) {
                return '#' + panel.id === link.hash;
            });
            if (index === -1) return;
            link.addEventListener('click', function (event) {
                event.preventDefault();
                activate(index, false);
                if (toggle) {
                    toggle.setAttribute('aria-expanded', 'false');
                    header.classList.remove('is-open');
                    document.documentElement.classList.remove('s26-menu-open');
                }
                group.scrollIntoView({ block: 'start' });
                tabs[index].focus({ preventScroll: true });
            });
        });
    });
    document.querySelectorAll('[data-testimonials]').forEach(function (group) {
        var slides = Array.from(group.querySelectorAll('.s26-quote-card'));
        var buttons = Array.from(group.querySelectorAll('[data-quote-index]'));
        var active = -1;
        var entered = reducedMotion.matches;
        group.classList.add('is-enhanced');
        function activate(index, replay) {
            if (index === active && !replay) return;
            active = index;
            slides.forEach(function (slide, i) {
                slide.hidden = i !== index;
                slide.inert = i !== index;
            });
            buttons.forEach(function (button) {
                button.setAttribute(
                    'aria-pressed',
                    String(Number(button.dataset.quoteIndex) === index),
                );
            });
            if (entered && !reducedMotion.matches) {
                slides[index]
                    .querySelectorAll('blockquote p, figcaption')
                    .forEach(function (text, i) {
                        text.getAnimations().forEach(function (animation) {
                            animation.cancel();
                        });
                        text.animate(
                            [
                                { opacity: 0, transform: 'translateY(16px)' },
                                { opacity: 1, transform: 'translateY(0)' },
                            ],
                            {
                                duration: 650,
                                delay: 300 + i * 120,
                                easing: 'ease-out',
                                fill: 'both',
                            },
                        );
                    });
            }
        }
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                activate(Number(button.dataset.quoteIndex));
            });
        });
        if (slides.length) {
            activate(0);
            var quoteEntrance = new IntersectionObserver(
                function (entries) {
                    if (
                        !entries.some(function (entry) {
                            return entry.isIntersecting;
                        })
                    )
                        return;
                    entered = true;
                    group.classList.add('has-entered');
                    activate(active, true);
                    quoteEntrance.disconnect();
                },
                { threshold: 0, rootMargin: '0px 0px -25% 0px' },
            );
            quoteEntrance.observe(group);
        }
        rotateSlides(
            group,
            slides,
            function () {
                return active;
            },
            activate,
        );
        enableSwipe(group.querySelector('.s26-slide-stage'), function (direction) {
            activate((active + direction + slides.length) % slides.length, false);
        });
    });
    Array.from(document.querySelectorAll('.s26-edge-shimmer'), function (shimmer) {
        return shimmer.parentElement;
    })
        .forEach(function (section) {
            var shimmer = section.querySelector('.s26-edge-shimmer');
            if (getComputedStyle(shimmer).display === 'none') return;
            new IntersectionObserver(function (entries) {
                shimmer.classList.toggle('is-visible', entries[0].isIntersecting);
            }).observe(section);
            new ResizeObserver(function () {
                var height = section.classList.contains('s26-edge-none') ? 0 :
                    parseFloat(getComputedStyle(section).getPropertyValue('--slant-height')) || 0;
                section.style.setProperty(
                    '--slant-angle',
                    Math.atan2(height, section.clientWidth) + 'rad',
                );
                var shimmer = section.querySelector('.s26-edge-shimmer');
                if (shimmer && Number.isFinite(height)) {
                    var gradient = section.querySelector('.s26-cta-gradient, .s26-closing-gradient');
                    var offset = gradient ? gradient.offsetTop : 0;
                    // Centre the flare on the actual edge, including the footer photo inset.
                    var productOverlap = section.classList.contains('s26-cta--media') && section.classList.contains('s26-overlap');
                    shimmer.style.right = productOverlap ? '2%' : '21%';
                    shimmer.style.top = (offset + height * (productOverlap ? .12 : .5)) + 'px';
                }
            }).observe(section);
        });
    var megaLinks = Array.from(document.querySelectorAll('.s26-service-nav a'));
    var desktopMenu = window.matchMedia('(min-width:1201px)');
    var previousMenuLink = '';
    try {
        previousMenuLink = sessionStorage.getItem('s26-menu-origin') || '';
        sessionStorage.removeItem('s26-menu-origin');
    } catch (error) { /* Hover state also works when browser storage is unavailable. */ }
    var megaTimer, lastMegaLink;
    function openMega(link, panel) {
        clearTimeout(megaTimer);
        if (!panel.hidden) return;
        closeMega();
        panel.hidden = false;
        panel.inert = false;
        link.setAttribute('aria-expanded', 'true');
        if (link._toggle) link._toggle.setAttribute('aria-expanded', 'true');
        if (!reducedMotion.matches) panel.animate([{ opacity: 0, transform: 'translateY(-8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 240, easing: 'ease-out' });
        lastMegaLink = link;
    }
    function closeMega() {
        megaLinks.forEach(function (link) {
            link.setAttribute('aria-expanded', 'false');
            if (link._toggle) link._toggle.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.s26-mega').forEach(function (panel) {
            panel.hidden = true;
            panel.inert = true;
        });
    }
    document.addEventListener('pointermove', function (event) {
        megaLinks.forEach(function (link) {
            if (!link.contains(event.target)) link._hoverBlocked = false;
        });
    });
    megaLinks.forEach(function (link, index) {
        var panel = document.getElementById('s26-mega-' + index);
        if (!panel) {
            link.addEventListener('pointerenter', function () {
                if (desktopMenu.matches) closeMega();
            });
            link.addEventListener('focus', function () {
                if (desktopMenu.matches) closeMega();
            });
            return;
        }
        link._hoverBlocked = link.matches(':hover') || link.href === previousMenuLink;
        var anchor = document.createComment('Desktop mega menu position');
        panel.before(anchor);
        var arrow = document.createElement('button');
        arrow.type = 'button';
        arrow.className = 's26-submenu-toggle';
        arrow.setAttribute('aria-label', 'Expand ' + link.textContent.trim());
        arrow.setAttribute('aria-controls', panel.id);
        arrow.setAttribute('aria-expanded', 'false');
        arrow.innerHTML = '<span aria-hidden="true">⌄</span>';
        link.after(arrow);
        link._toggle = arrow;
        arrow.addEventListener('click', function () {
            if (panel.hidden) openMega(link, panel);
            else closeMega();
        });
        function arrangeMenu() {
            closeMega();
            if (desktopMenu.matches) anchor.after(panel);
            else link.closest('li').appendChild(panel);
        }
        desktopMenu.addEventListener('change', arrangeMenu);
        arrangeMenu();
        link.setAttribute('aria-controls', panel.id);
        link.setAttribute('aria-expanded', 'false');
        link.addEventListener('pointerenter', function () {
            if (desktopMenu.matches && !link._hoverBlocked) {
                clearTimeout(megaTimer);
                openMega(link, panel);
            }
        });
        link.addEventListener('pointerleave', function () {
            link._hoverBlocked = false;
        });
        link.addEventListener('focus', function () {
            if (desktopMenu.matches && link.matches(':focus-visible')) openMega(link, panel);
        });
        link.addEventListener('click', function (event) {
            if (!desktopMenu.matches && panel.hidden && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && link.target !== '_blank') {
                event.preventDefault();
                openMega(link, panel);
                return;
            }
            if (!event.ctrlKey && !event.metaKey && !event.shiftKey && link.target !== '_blank') {
                try { sessionStorage.setItem('s26-menu-origin', link.href); } catch (error) {}
                link._hoverBlocked = true;
            }
            closeMega();
        });
        link.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                openMega(link, panel);
                var first = panel.querySelector('a');
                if (first) first.focus();
            }
        });
        panel.addEventListener('pointerenter', function () {
            clearTimeout(megaTimer);
        });
        panel.addEventListener('pointerleave', function () {
            if (window.matchMedia('(min-width:1201px)').matches)
                megaTimer = setTimeout(closeMega, 120);
        });
    });
    var serviceNav = document.querySelector('.s26-service-nav');
    var navigation = document.querySelector('.s26-navigation');
    if (serviceNav && navigation) {
        var originalChildren = Array.from(navigation.children);
        function arrangeNavigation() {
            if (desktopMenu.matches) {
                document.documentElement.classList.remove('s26-menu-open');
                navigation.after(serviceNav);
                originalChildren.forEach(function (child) { navigation.appendChild(child); });
            } else {
                document.documentElement.classList.toggle('s26-menu-open', header.classList.contains('is-open'));
                navigation.before(serviceNav);
                ['.s26-button', '.s26-contractors', 'nav', '.s26-search'].forEach(function (selector) {
                    var child = navigation.querySelector(selector);
                    if (child) navigation.appendChild(child);
                });
            }
        }
        desktopMenu.addEventListener('change', arrangeNavigation);
        arrangeNavigation();
    }
    if (serviceNav)
        serviceNav.addEventListener('pointerleave', function () {
            if (window.matchMedia('(min-width:1201px)').matches)
                megaTimer = setTimeout(closeMega, 120);
        });
    document.addEventListener('click', function (event) {
        if (!event.target.closest('.s26-header')) closeMega();
    });
    if (header) header.addEventListener('focusout', function () {
        setTimeout(function () { if (!header.contains(document.activeElement)) closeMega(); }, 0);
    });
    document.addEventListener('keydown', function (event) {
        if (
            event.key === 'Escape' &&
            lastMegaLink &&
            lastMegaLink.getAttribute('aria-expanded') === 'true'
        ) {
            closeMega();
            (desktopMenu.matches ? lastMegaLink : lastMegaLink._toggle).focus();
            closeMega();
        }
    });
    if (toggle)
        toggle.addEventListener('click', function () {
            if (toggle.getAttribute('aria-expanded') === 'false') closeMega();
        });
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            closeMega();
            megaLinks.forEach(function (link) { link._hoverBlocked = link.matches(':hover'); });
        }
    });
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
        var track = carousel.querySelector('.s26-insight-track');
        function updateControls() {
            carousel.querySelector('[data-direction="-1"]').disabled = track.scrollLeft <= 1;
            carousel.querySelector('[data-direction="1"]').disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        }
        track.addEventListener('scroll', updateControls, {passive:true});
        new ResizeObserver(updateControls).observe(track);
        updateControls();
        var cards = Array.from(track.children),
            active = 0;
        function move(index) {
            active = (index + cards.length) % cards.length;
            track.scrollTo({
                left: cards[active].offsetLeft - track.offsetLeft,
                behavior: reducedMotion.matches ? 'auto' : 'smooth',
            });
        }
        carousel.querySelectorAll('[data-direction]').forEach(function (button) {
            button.addEventListener('click', function () {
                move(active + Number(button.dataset.direction));
            });
        });
        rotateSlides(
            carousel,
            cards,
            function () {
                return active;
            },
            move,
        );
        enableSwipe(track, function (direction) {
            move(active + direction);
        });
    });
    document.querySelectorAll('.s26-faqs, .s26-split-copy:has(.s26-split-point), .s26-benefit-grid, .s26-service-accordion').forEach(function (group, groupIndex) {
        var details = Array.from(group.querySelectorAll('details'));
        if (!reducedMotion.matches) {
            details.forEach(function (item) {
                item.style.opacity = '0';
                item.style.transform = 'translateY(18px)';
            });
            var entrance = new IntersectionObserver(
                function (entries) {
                    if (
                        !entries.some(function (entry) {
                            return entry.isIntersecting;
                        })
                    )
                        return;
                    details.forEach(function (item, i) {
                        var animation = item.animate(
                            [
                                { opacity: 0, transform: 'translateY(18px)' },
                                { opacity: 1, transform: 'translateY(0)' },
                            ],
                            {
                                duration: 500,
                                delay: 300 + i * 120,
                                easing: 'ease-out',
                                fill: 'both',
                            },
                        );
                        animation.onfinish = function () {
                            item.style.opacity = '1';
                            item.style.transform = '';
                        };
                    });
                    entrance.disconnect();
                },
                { threshold: 0, rootMargin: '0px 0px -25% 0px' },
            );
            entrance.observe(group);
        }
        function change(item, open) {
            var start = item.getBoundingClientRect().height;
            if (item._animation) item._animation.cancel();
            item._targetOpen = open;
            item.style.height = '';
            item.open = open;
            var end = item.getBoundingClientRect().height;
            if (reducedMotion.matches || Math.abs(start - end) < 1) {
                item.style.overflow = '';
                item._animation = null;
                return;
            }
            // Keep the answer rendered while its container closes.
            item.open = true;
            item.style.overflow = 'hidden';
            var animation = item.animate(
                [{ height: start + 'px' }, { height: end + 'px' }],
                { duration: 260, easing: 'cubic-bezier(.25,.1,.25,1)' }
            );
            item._animation = animation;
            animation.onfinish = function () {
                if (item._animation !== animation) return;
                item.open = open;
                item.style.overflow = '';
                item._animation = null;
            };
        }
        details.forEach(function (item) {
            item.removeAttribute('name');
            item._targetOpen = item.open;
            item.querySelector('summary').addEventListener('click', function (event) {
                event.preventDefault();
                var opening = !item._targetOpen;
                details.forEach(function (other) {
                    if (other !== item && other._targetOpen) change(other, false);
                });
                change(item, opening);
            });
        });
    });
    document.querySelectorAll('.wpcf7 [placeholder]').forEach(function (field) {
        if (!field.getAttribute('aria-label')) field.setAttribute('aria-label', field.placeholder);
    });
    var footer = document.querySelector('.s26-footer');
    if (footer) {
        footer.classList.add('s26-footer-reveal');
        var queued = false;
        function revealFooter() {
            queued = false;
            var remaining =
                document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
            var distance = Math.min(window.innerHeight * 0.65, 500);
            var progress = reducedMotion.matches
                ? 1
                : Math.max(0, Math.min(1, 1 - remaining / distance));
            footer.style.setProperty('--logo-offset', 105 - 105 * progress + '%');
        }
        window.addEventListener(
            'scroll',
            function () {
                if (!queued) {
                    queued = true;
                    requestAnimationFrame(revealFooter);
                }
            },
            { passive: true },
        );
        window.addEventListener('resize', revealFooter);
        reducedMotion.addEventListener('change', revealFooter);
        new ResizeObserver(revealFooter).observe(document.body);
        revealFooter();
    }
});
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.s26-cards--steps').forEach(function (section) {
        var cards = Array.from(section.querySelectorAll('article')),
            label = section.querySelector('.s26-step-current');
        function update() {
            var active = 0;
            cards.forEach(function (card, i) {
                if (card.getBoundingClientRect().top < innerHeight * 0.55) active = i;
            });
            cards.forEach(function (card, i) {
                card.classList.toggle('is-active', i === active);
            });
            if (cards[active])
                label.textContent =
                    'Step ' + (active + 1) + ' — ' + cards[active].dataset.stepTitle.replace(/^\s*(?:Step\s+)?\d+\s*[.)\u2014\u2013:-]\s*/i, '');
        }
        window.addEventListener('scroll', update, { passive: true });
        update();
    });
});
document.addEventListener('DOMContentLoaded', function () {
    requestAnimationFrame(function () {
        document.documentElement.classList.add('s26-motion-ready');
    });
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.s26-table-tabs').forEach(function (tabs) {
        var buttons = Array.from(tabs.querySelectorAll('[role="tab"]'));
        function select(index) {
            buttons.forEach(function (button, i) {
                var active = i === index;
                button.setAttribute('aria-selected', active ? 'true' : 'false');
                button.tabIndex = active ? 0 : -1;
                document.getElementById(button.getAttribute('aria-controls')).hidden = !active;
            });
            buttons[index].focus();
        }
        buttons.forEach(function (button, index) {
            button.addEventListener('click', function () { select(index); });
            button.addEventListener('keydown', function (event) {
                var next = event.key === 'ArrowRight' ? index + 1 : event.key === 'ArrowLeft' ? index - 1 : null;
                if (event.key === 'Home') next = 0;
                if (event.key === 'End') next = buttons.length - 1;
                if (next === null) return;
                event.preventDefault();
                select((next + buttons.length) % buttons.length);
            });
        });
    });
});

